import React, { useEffect } from 'react';
import { getInfluencers } from '../../store/slices/influencer/asyncThunk';
import { APPEARANCE, HOME } from '../../components/App/routes';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  AppearanceTags,
  InfluencerCard,
  LogoComponent,
  PersonalitiesPageSkeleton,
  PremiumButton,
  PublicHeader,
} from '../../components';
import {
  Container,
  Content,
  ContentContainer,
  Header,
  LogoContainer,
  NotebookHeader,
  PremiumButtonWrapper,
} from './AppearancesPage.styles';
import { ReactComponent as ChevronLeft } from '../../assets/icons/chevron_left.svg';
import { selectGetInfluencersPending, selectInfluencers } from '../../store/slices/influencer/slice';
import { useMediaQuery } from 'react-responsive';
import { TagsContainer } from '../HomePage/HomePage.styles';

const AppearancesPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { appearanceName } = useParams();
  const { pathname } = useLocation();

  const getInfluencersPending = useSelector(selectGetInfluencersPending);
  const influencers = useSelector(selectInfluencers);

  const isMobile = useMediaQuery({ minWidth: 0, maxWidth: 550 });

  const onAppearanceTagClick = value => {
    navigate(`/${APPEARANCE.replace(':appearanceName', value)}`);
  };

  useEffect(() => {
    if (appearanceName) {
      dispatch(getInfluencers({ appearanceTags: [appearanceName], personalityTags: [] }));
    }
  }, [appearanceName, dispatch]);

  const onBack = () => {
    navigate(`${HOME}`);
  };

  return (
    <Container>
      <NotebookHeader>
        <PublicHeader backText="Popular Hashtags" onBack={onBack} />
      </NotebookHeader>
      <Header>
        <LogoContainer onClick={onBack}>
          <ChevronLeft />
        </LogoContainer>
        <LogoComponent id="personalityPage" />
        <PremiumButtonWrapper>
          <PremiumButton />
        </PremiumButtonWrapper>
      </Header>
      <ContentContainer>
        <TagsContainer>
          <AppearanceTags hideTitle onTagClick={onAppearanceTagClick} selectedTag={appearanceName} />
        </TagsContainer>
        {getInfluencersPending ? (
          <Content>
            <PersonalitiesPageSkeleton />
          </Content>
        ) : (
          <Content>
            {influencers.map(influencer => {
              return (
                <InfluencerCard
                  key={influencer.id}
                  id={influencer.id}
                  name={influencer.name}
                  isVerified={influencer.isVerified}
                  image={influencer.image}
                  username={influencer.username}
                  age={influencer.age}
                  aboutMe={influencer.aboutMe}
                  chatButton={!isMobile}
                  aspectRatio={isMobile ? 0.48 : 3 / 4}
                  category={influencer.category}
                  from={pathname}
                  callOptions={influencer.callOptions}
                />
              );
            })}
          </Content>
        )}
      </ContentContainer>
    </Container>
  );
};

export default AppearancesPage;
